<template>
  <div id="tipsOne"></div>
</template>

<script>
export default {
  name: "TipsOne",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        title: "5 LinkedIn Tips",
        items: [
          "Post consistently at peak hours",
          "Use carousels for higher reach",
          "Reply to every comment",
        ],
        chip: "Tips",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    isDarkColor(color) {
      let r, g, b;
      if (color.startsWith("#")) {
        const hex = color.slice(1);
        if (hex.length === 3) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        }
      } else {
        const rgb = color.match(/\d+/g);
        if (!rgb || rgb.length < 3) return false;
        r = parseInt(rgb[0]);
        g = parseInt(rgb[1]);
        b = parseInt(rgb[2]);
      }
      const brightness = (r * 299 + g * 587 + b * 114) / 1000;
      return brightness < 128;
    },
    render() {
      const el = document.getElementById("tipsOne");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const titleSize = exporting ? 56 : 56 * this.scale;
      const itemSize = exporting ? 36 : 36 * this.scale;
      const numberSize = exporting ? 32 : 32 * this.scale;
      const logoHeight = exporting ? 50 : 50 * this.scale;
      const chipSize = exporting ? 24 : 24 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#000000";

      const items = this.data.items || [];
      const itemsHtml = items
        .map(
          (item, index) => `
        <div style="display: flex; align-items: flex-start; margin-bottom: 24px;">
          <div style="
            min-width: ${numberSize * 1.5}px;
            height: ${numberSize * 1.5}px;
            background: ${primaryColor};
            color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: ${numberSize}px;
            font-weight: 600;
            margin-right: 20px;
            flex-shrink: 0;
          ">${index + 1}</div>
          <div style="
            font-size: ${itemSize}px;
            font-weight: 400;
            color: #272727;
            line-height: 1.4;
            padding-top: 4px;
          ">${item}</div>
        </div>
      `,
        )
        .join("");

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #f5f5f5;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
          "
        >
          <div style="padding: 10%">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <div style="padding: 0 10%; flex: 1;">
            <div style="border-left: 6px solid #272727; padding-left: 25px; margin-bottom: 40px;">
              <div style="
                font-size: ${titleSize}px;
                font-weight: 600;
                color: #272727;
                line-height: 1.2;
              ">${this.data.title}</div>
            </div>

            <div style="padding-left: 31px;">
              ${itemsHtml}
            </div>
          </div>

          <div style="padding: 10%">
            <div style="display: flex;">
              <span
                style="
                  display: inline-block;
                  background: ${primaryColor};
                  color: ${this.isDarkColor(primaryColor) ? "#fff" : "#000"};
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 7px 22px;
                  letter-spacing: 0.03em;
                  font-family: 'Inter', Arial, sans-serif;
                  box-shadow: 0 1px 2px rgba(39, 39, 39, 0.03);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
